import React from 'react';
import styled from 'styled-components';
import * as api from '@ubeya/shared/services/api';
import { ALLOWED_PHOTO_TYPES } from '@ubeya/shared/constants';
import { smallSemiBold, FileUpload as BaseFileUpload, flexCenter } from '@ubeya/shared-web/components';
import useArrayManagement from '@ubeya/shared-web/hooks/useArrayManagement';
import { ReactComponent as PlusIcon } from '@ubeya/shared-web/assets/plus.svg';

const FileUpload = styled(BaseFileUpload)`
  ${flexCenter};
  width: 100px;
  height: 100px;
  margin: 0 30px 30px 0;
  cursor: pointer;
  ${smallSemiBold};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border: 1px dashed ${({ theme }) => theme.colors.grey2};
  text-align: center;
  outline: none;

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};

    path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const AddPhoto = () => {
  const { handleAddItems } = useArrayManagement('photos');

  return (
    <FileUpload apiFunc={api.uploadImage} onUploaded={handleAddItems} accept={ALLOWED_PHOTO_TYPES}>
      <PlusIcon />
    </FileUpload>
  );
};

export default AddPhoto;
